export default __webpack_public_path__ + "static/media/HINO.b3045d8b.png";